

































import { WatchOptions } from 'vue';
import { Component, Prop, Vue ,  Watch} from 'vue-property-decorator';

@Component
export default class SearchFilter extends Vue {
    @Prop({default: "Generic Search!"})
    placeholder: string
    @Prop({default: true})
    isFilterActive: boolean
    @Prop({default: false})
    isCollapseVisible: boolean
    @Prop({default: false})
    filterSelected: boolean
    @Prop({default: false})
    activeFilterFromWidget: boolean

    collapsibleIsOpen : boolean = false;
    // @Prop({ type: Boolean, default: false })
    // collapsibleIsOpen;
    searchText: string = ""
    inputTextClasses: string = "left-rounded-border"
    emitResetEvent(): void {
        this.searchText = ""
        this.$emit("filter-reset")
    }

    emitSearchEvent(): void {
        this.$emit("filter-search", this.searchText)
    }

    toggle(): void {
        this.collapsibleIsOpen = !this.collapsibleIsOpen
        let filterSearchIcon = document.getElementById("filterSearchIcon")
        if (this.collapsibleIsOpen) {
            filterSearchIcon.classList.add("rotate-90-deg")
            this.$emit("open-filter-search")
        }
        else {
            filterSearchIcon.classList.remove("rotate-90-deg")
            this.$emit("close-filter-search")
        }
    }

    mounted():void {
        //nel caso in cui abbia cliccato sul title dei widget communication simulo una ricerca con il tab aperto
        if(this.activeFilterFromWidget) {
            let filterSearchIcon = document.getElementById("filterSearchIcon")
            this.collapsibleIsOpen = true;
            filterSearchIcon.classList.add("rotate-90-deg")
            this.$emit("open-filter-search")
        }
    }

    created(): void {
        if (!this.isFilterActive)
            this.inputTextClasses = this.inputTextClasses +  " right-rounded-border"
        this.$emit("open-filter-search");
    }

    get colorChange(){
        if (this.filterSelected){
            return 'secondary';
        }
        return 'outline-secondary';
    }

}
